import React from 'react';
import clsx from 'clsx';
import './Inputs.scss';
import { Label } from './Label';
import { endOfDay, isAfter } from 'date-fns';
import { DatePicker, SelectPicker } from 'rsuite';
import { TypeAttributes } from 'rsuite/cjs/internals/types';
import { PickerData } from '../../form/form-input-constants';

interface Props {
	formik?: any;
	inputType?: string;
	placeholder?: string;
	fieldLabel?: string;
	fieldName?: string;
	checkboxFieldName?: string;
	onInputClick?: () => void;
	onSelectFile?: (e: any) => void;
	readOnly?: boolean;
	disabled?: boolean;
	additionalClass?: string;
	imageAdditionalClass?: string;
	uploadedFile?: string;
	placement?: TypeAttributes.Placement;
	selectPickerData?: PickerData[];
	searchable?: boolean;
	cleanable?: boolean;

}

export const Input = (props: Props): React.ReactElement => {
	const {
		formik,
		fieldLabel,
		fieldName,
		checkboxFieldName,
		inputType,
		placeholder,
		onInputClick,
		readOnly,
		additionalClass,
		disabled,
		onSelectFile,
		uploadedFile,
		imageAdditionalClass,
		placement = 'bottomStart',
		selectPickerData,
		searchable,
		cleanable
	} = props;

	let value;
	if (fieldName) {
		const formikValue = formik?.getFieldProps(fieldName);
		value = formikValue?.value;
	}

	switch (inputType) {
		case 'file': {
			return (
				<>
					<input
						type={inputType}
						className="form-control form-control-sm form-control-solid mt-1 download-file-origin"
						onChange={onSelectFile}
						onClick={(event: any): void => {
							event.target.value = null;
						}}
						accept="image/png, image/jpg, image/jpeg"
					/>
					<div className="download-file-fake px-5">
						{
							uploadedFile &&
							<img src={uploadedFile} alt="logo" className={imageAdditionalClass}/>
						}
					</div>
				</>
			);
		}
		case 'checkbox': {
			return (
				<div className="d-flex align-items-center form-check">
					<input
						{...formik.getFieldProps(checkboxFieldName)}
						type={inputType}
						className={clsx('form-check-input cursor-pointer checkbox-size', additionalClass)}
						disabled={disabled}
						checked={!!formik.getFieldProps(checkboxFieldName).value}
					/>
					<Label fieldLabel={fieldLabel} additionalClass="form-check-label ms-5 fs-6"/>
				</div>
			);
		}
		case 'date': {
			return (
				<div className="form-input-picker-container">
					<DatePicker
						value={value}
						oneTap
						placeholder="Select Date"
						onChange={(dateValue): void => {
							formik.setFieldValue(fieldName, new Date(dateValue));
						}}
						onClean={(): void => {
							formik.setFieldValue(fieldName, null);
						}}
						className="mt-1 w-100 date-picker-custom"
						shouldDisableDate={(date): boolean => isAfter(date, endOfDay(new Date()))}
						placement={placement}
					/>
				</div>
			);
		}
		case 'select': {
			return (
				<div className="input-container">
					<SelectPicker
						className="p-0 select-picker"
						data={selectPickerData}
						placeholder={placeholder ? `Select ${placeholder}` : ''}
						name={fieldName}
						value={value}
						placement={placement}
						onChange={(selectorValue): void => {
							formik.setFieldValue(fieldName, selectorValue);
						}}
						disabled={Boolean(disabled)}
						searchable={searchable}
						cleanable={cleanable}
					/>
				</div>
			);
		}
		default: {
			return (
				<input
					{...formik.getFieldProps(fieldName)}
					type={inputType}
					className={clsx(
						'form-control form-control-sm form-control-solid mt-1',
						inputType === 'number' && 'number-input-zip',
						additionalClass
					)}
					onClick={onInputClick}
					placeholder={placeholder}
					readOnly={readOnly}
				/>
			);
		}
	}
};
